import { render, staticRenderFns } from "./ClientCreateOrderNew.vue?vue&type=template&id=1e742f87&scoped=true"
import script from "./ClientCreateOrderNew.vue?vue&type=script&lang=js"
export * from "./ClientCreateOrderNew.vue?vue&type=script&lang=js"
import style0 from "./ClientCreateOrderNew.vue?vue&type=style&index=0&id=1e742f87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e742f87",
  null
  
)

export default component.exports